export default __webpack_public_path__ + "static/media/landscape10.732d03a9.JPG";